"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ColorSelector_1 = require("./ColorSelector");
exports.default = ColorSelector_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ColorSelector/index.js
// module id = 1758
// module chunks = 8